import { z } from "zod";
import { Scope,Profile } from "./ai-model-control.ts";
import { NativeOperationsPlannerOutput,NativeSurfacePlannerOutput } from "./work-os/planning-model.ts";
import { Result,Response } from "./ai-preparation-reply.ts";
export const Command=z.object({scope:Scope,profile:Profile,expectedRunRevision:z.number().int().positive(),output:z.union([NativeOperationsPlannerOutput,NativeSurfacePlannerOutput])}).strict();
export type Command=z.infer<typeof Command>;
export { Result,Response };
export const PATH="/api/internal/v1/ai-plan-candidates";
export const CONTRACT_VERSION="1.0.0";
